const printLog = (header, arg) => {
  if (process.env.NODE_ENV !== 'production') {
    console.log(`%c ${header}    ${arg}`, 'color: #ffd1aa');
  }
};

const getStorage = () => {
  try {
    if (window && window.localStorage) {
      return window.localStorage;
    }
  } catch (e) {}
  let store = {};
  return {
    getItem(key) {
      return store[key];
    },
    setItem(key, value) {
      store[key] = value.toString();
    },
    removeItem(key) {
      delete store[key];
    },
    clear() {
      store = {};
    },
  };
};

const storage = getStorage();
const bootTime = new Date() / 1000;

const get = (k) => {
  try {
    return storage.getItem(k) ? JSON.parse(storage.getItem(k)) : undefined;
  } catch (e) {
    return undefined;
  }
};

const set = (k, v) => {
  try {
    Promise.resolve(storage.setItem(k, JSON.stringify(v))).catch((e) => {
      storage.clear();
    });
  } catch (e) {
    storage.clear();
  }
};

const del = (k) => storage.removeItem(k);

const clear = () => storage.clear();

const localCache = {
  clearPrefix: (prefix) => {
    const now = new Date() / 1000;
    const key = `${prefix}`;
    Object.keys(storage).map((k) => {
      if (k === key) {
        printLog(
          `<<<localCache ${Math.round(now - bootTime)}s >>>`,
          `DELETE ${k} prefix: ${prefix}`
        );
        del(k);
      }
      return k;
    });
    return true;
  },

  clear: () => {
    clear();
  },

  write: (k, data, expiryTime = 3600) => {
    const now = new Date() / 1000;
    const till = Math.round(now + expiryTime);
    const key = `${k}`;
    Object.keys(storage).forEach((i) => {
      const oldValue = get(i) || {};
      if (now > oldValue.expiryTime) {
        printLog(
          `<<<localCache ${Math.round(now - bootTime)}s >>>`,
          `DELETE ${i} expired: ${now - oldValue[i] || '<err>'}s ago`
        );
        del(i);
      }
    });
    set(key, { data, expiryTime: till });
    printLog(
      `<<<localCache ${Math.round(now - bootTime)}s >>>`,
      `WRITE ${k} for ${expiryTime}s`
    );
    return data;
  },

  read: (k, defaultData) => {
    const key = `${k}`;
    const { data, expiryTime } = get(key) || {};
    const now = new Date() / 1000;

    if (expiryTime >= now) {
      printLog(
        `<<<localCache ${Math.round(now - bootTime)}s >>>`,
        `READ (hit) ${k} valid for ${Math.round(expiryTime - now)}s`
      );
      return data;
    }
    printLog(
      `<<<localCache ${Math.round(now - bootTime)}s >>>`,
      `READ (miss) ${k} ${
        expiryTime ? `expired ${now - expiryTime}s ago.` : ''
      }`
    );

    return defaultData;
  },

  fetch: (key, expiryTime, fn) => {
    const value = localCache.read(key);
    if (value) {
      return Promise.resolve(value);
    }
    return Promise.resolve(fn()).then((val) => {
      localCache.write(key, val, expiryTime);
      return val;
    });
  },
};

export default localCache;



// WEBPACK FOOTER //
// ./components/transaction/src/utils/localCache.js